import React from 'react';
import PropTypes from 'prop-types';
import RenderComponentProto from '../../render-component-proto';

export default class RatingComponentProto extends RenderComponentProto {
    static propTypes = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new','t-list']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        canEdit: false,
    };

    constructor(props) {
        super(props);

        const cf = gd.session.customFields.get(this.props.id);
        const stars = cf.params.ratingType;

        this.state = {
            value: props.value,
            newValue: null,
            interacting: false,
            stars: stars
        };
    }

    onOptionClick = (value) => {
        this.setState({ value: value }, () => {
            if (this.props.onChange) this.props.onChange(value);
            this.hidePopover()
        });
    }

    onResetClick = () => {
        this.onStarClick(null);
    }

    onStarClick = (index) => {
        if (!this.props.canEdit) return false;

        this.setState({
            value: index
        });

        if (this.props.onChange) this.props.onChange(index);
    }

    onStarMouseEnter = (index) => {
        if (!this.props.canEdit) return false;

        this.setState({
            newValue: index
        })
    }

    onStarMouseLeave = (index) => {
        if (!this.props.canEdit) return false;

        this.setState({
            newValue: null
        })
    }

    onMouseEnter = () => {
        if (!this.props.canEdit) return false;

        this.setState({
            interacting: true,
            newValue: this.state.value
        });
    }

    onMouseLeave = () => {
        if (!this.props.canEdit) return false;

        this.setState({
            displayValue: this.props.value,
            interacting: false
        });
    }

    renderStatic() {
        const { value } = this.state;
        const classes = Classes('gd-field-rating', this.props.renderMode,  {
            'disabled': this.props.canEdit === false,
            'not-set': !value,
        });

        const cf = gd.session.customFields.get(this.props.id);
        const stars = cf.params.ratingType;
        const res = [];


        if (['edit','list','t-list'].includes(this.props.renderMode)) {
            for (let i=1; i<=stars; i++) {
                const icon = (i<=value)?"i5-star":"i5-star-empty";
                res.push(<div key={i} className={icon}/>)
            }
        } else {
            for (let i=1; i<=stars; i++) {
                const icon = (i<=value)?"i5-star":"i5-star-empty invisible";
                res.push(<div key={i} className={icon}/>)
            }
        }

        return (
            <div className={classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                <div className="field-holder">
                    {res}
                    {/*{<div className="ui5-ico-delete s14 gray invisible"/>}*/}
                </div>
            </div>
        );
    }

    renderInteracting() {
        const value = this.state.newValue ? this.state.newValue : this.state.value;

        const classes = Classes('gd-field-rating', this.props.renderMode, {
            'disabled': this.props.canEdit === false,
            'not-set': !value,
        });

        const res = [];

        for (let i=1; i<=this.state.stars; i++) {
            const icon = (i<=value)?"i5-star":"i5-star-empty";
            res.push(
                <div key={i} className={icon} onClick={this.onStarClick.bind(this,i)} onMouseEnter={this.onStarMouseEnter.bind(this,i)} onMouseLeave={this.onStarMouseLeave.bind(this,i)}/>
            )
        }

        return (
            <div className={classes} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                <div className="field-holder">
                    {res}

                    {this.props.canEdit &&
                    <React.Fragment>
                        {this.state.value && <div className="ui5-ico-delete s14 gray" onClick={this.onResetClick}/>}
                        {/*{!this.state.value && <div className="ui5-ico-delete s14 gray invisible"/>}*/}
                    </React.Fragment>}
                </div>
            </div>
        );
    }

    render() {
        return this.state.interacting ? this.renderInteracting() : this.renderStatic();
    }
}